import { appendUTMToURL } from '@common/helpers/url';
import { default as Image } from '@react/shared/components/Image';
import { Button } from '@react/system';
import {
  CARE_SCOUT_PRICING_PLANS_URL,
  CARE_SCOUT_PRICING_PLANS_UTM_PARAMS,
} from '@sly/core/constants';
import { CARE_SCOUT_PRICING_PLAN_IMAGE_URL } from '@sly/core/constants/image';
import { Checkmark } from '@sly/icons/react';
import React, { useCallback } from 'react';

const whatYouGetPoints = [
  'Professional care evaluation by a licensed nurse',
  'Personalized recommendations that address the full range of aging care',
  'Support when you need it - call us with any questions you have',
];
function CarePlans() {
  const handleLearnMore = useCallback(() => {
    const carePlansURL = appendUTMToURL(
      CARE_SCOUT_PRICING_PLANS_URL,
      CARE_SCOUT_PRICING_PLANS_UTM_PARAMS.tools
    );
    window.open(carePlansURL, '_blank');
  }, []);
  return (
    <div className='flex  flex-col-reverse gap-8 lg:flex-row'>
      <div className='lg:pb-8'>
        <h2 className='font-t-m mb-4 capitalize-first'>
          Get a Care Plan made just for you
        </h2>
        <div className='font-b-m'>
          A Care Plan is a personalized guide created by a licensed nurse to
          help you understand the types of care, resources, and support that may
          be right for you.
        </div>
        <div>
          <div className='font-b-m mt-8 mb-4 font-semibold'>
            What’s included:
          </div>
          {whatYouGetPoints?.map((point, index) => (
            <div key={index} className='my-4 flex items-center gap-2'>
              <Checkmark className='h-6 w-6 text-viridian-base' />
              <div className='font-b-m'>{point}</div>
            </div>
          )) || null}
        </div>
        <div className='mt-8'>
          <Button
            onClick={handleLearnMore}
            eventProps={{
              location: 'care-plans-tools-page',
              text: 'learn more',
            }}
            className='w-full !px-8 md:w-auto'
          >
            Learn more
          </Button>
        </div>
      </div>
      <div className='h-[440px] w-[320px] flex-shrink-0 lg:h-auto'>
        <div className='relative h-full w-full'>
          <Image
            path={CARE_SCOUT_PRICING_PLAN_IMAGE_URL}
            className='absolute top-0 left-0 h-full w-full object-contain'
            alt='carePricingPlans'
          />
        </div>
      </div>
    </div>
  );
}

export default CarePlans;
